import { z } from "zod";

const roomSystemOptionSchema = z.object({
  id: z.string(),
  name: z.string(),
  organisationId: z.string(),
  organisationName: z.string(),
  conflictingSessions: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      start: z.string(),
      end: z.string(),
    }),
  ),
});

const registerRoomSystemToEventSchema = z.object({
  roomSystems: z.array(roomSystemOptionSchema),
});

type RegisterRoomSystemToEventSchema = z.infer<
  typeof registerRoomSystemToEventSchema
>;

export {
  registerRoomSystemToEventSchema,
  type RegisterRoomSystemToEventSchema,
};
